<!--
 * @Author: mzw
 * @Date: 2025-04-24 14:50:19
 * @LastEditTime: 2025-05-09 14:53:25
 * @LastEditors: mzw
 * @Description: 
-->
<template>
  <div class="chat-line chat-line-reply">
    <div class="chat-line-inner">
      <div class="chat-icon">
        <img src="~@/assets/img/AI/gpt1.png" alt="ChatGPT" />
      </div>
      <div class="chat-item">
        <!-- 内容 -->
        <template v-if="!isOCRContent">
          <template v-if="itemObj.AIAnswering">
            <p class="rf ac" style="min-height:40px;">
              {{itemObj.content}}
              <!-- <el-icon class="is-loading loading-icon">
                <img src="~@/assets/img/AI/AI_model3.png" alt="Loading" />
              </el-icon> -->
              <span class="is-loading">
                <img src="~@/assets/img/AI/AI_model3.png" alt="Loading" />
              </span>
            </p>
          </template>
          <!-- 流式输出内容加markdownCont样式 -->
          <div v-else class="content" v-html="itemObj.content" @click="clickContent"
            :class="{markdownCont : ['bigModelChat', 'materialAssistant', 'sourceAssistant', 'AISuperSearch'].includes(itemObj.questionType)}"
          ></div>
        </template>
        <!-- OCR识别结果内容 -->
        <div class="content content-ocr" v-else>
          <!-- 顶部 -->
          <div class="top-bar">
            <span class="title">识别结果返回</span>
            <el-tabs v-model="ocrActiveType" @tab-click="selectDataType">
              <el-tab-pane label="键值对" name="1" v-if=" ocrContentObj.key_values && ocrContentObj.key_values.length>0 "></el-tab-pane>
              <el-tab-pane label="表格" name="2" v-if=" ocrTableKeyList.length>0 || ocrTableHtml!=='' "></el-tab-pane>
              <el-tab-pane label="JSON" name="3"></el-tab-pane>
            </el-tabs>
            <el-popover
              placement="bottom"
              width="400"
              trigger="manual"
              v-model="downTypeVisible"
              ref="downTypePopover"
              :fallback-placements="['bottom','top','right','left']">
              <div class="down-type-box">
                <!-- downType：未下载过类型(1:excel, 2:word, 3:excel+word, 0指都下载过)
                     未下载过（或无downType值(null或undefined)：初始创建问答、还未加载列表接口、无downType字段）则高亮展示
                -->
                <el-button
                  text
                  :loading="ocrDownloading"
                  @click="ocrResultExport('excel')"
                  :type="isNaN(parseFloat(itemObj.downType)) || [1,3].includes(itemObj.downType) ? 'primary' : ''"
                >excel</el-button>
                <el-button
                  text
                  :loading="ocrDownloading"
                  @click="ocrResultExport('word')"
                  :type="isNaN(parseFloat(itemObj.downType)) || [2,3].includes(itemObj.downType) ? 'primary' : ''"
                  >word</el-button>
              </div>
              <template v-slot:reference>
                <span
                  class="down-box"
                  v-if="!itemObj.unneedHandle"
                >
                  <i
                    class="plantmate"
                    :class="'plantmate-forms-softwareDownloadReport'"
                  ></i>
                  下载结果
                </span>
              </template>
            </el-popover>
          </div>
          <!-- 内容展示 -->
          <div class="data-box">
            <!-- 键值对 -->
            <div
              class="form-box"
              v-if="ocrActiveType==='1' && ocrContentObj.key_values && ocrContentObj.key_values.length>0"
            >
              <el-descriptions :column="1">
                <el-descriptions-item
                  v-for="(item, index) in ocrContentObj.key_values"
                  :key="index"
                  :label="item.key+'：'"
                >
                  {{item.value}}
                  <Copyable
                    :text="item.value"
                    :color="'#1d65a8'"
                  ></Copyable>
                </el-descriptions-item>
              </el-descriptions>
            </div>
            <!-- 表格 --> 
            <div
              class="table-box"
              v-if="ocrActiveType==='2' && (ocrTableKeyList.length>0 || ocrTableHtml!=='')"
            >
              <div class="handle-box">
                <span class="bar-icon" @click="reviewOcrTable">
                  <i class="el-icon-view"></i>
                  <span>预览</span>
                </span>
                <em class="tips" v-if="ocrTableKeyList.length>0">
                  仅展示100条以内数据，更多数据点击预览或者下载结果查看
                </em>
              </div>
              <!-- 票证类型表格渲染（有tables渲染tables） -->
              <el-table
                v-if="ocrTableKeyList.length>0"
                :data="ocrContentObj.tables[0].slice(0,100)"
                size="small"
                border
                style="width: 100%"
                max-height="700"
                :header-cell-style="{ 'background-color': '#f5f7fa', padding: '5px 0' }"
              >
                <el-table-column
                  v-for="(item, index) in ocrTableKeyList"
                  :key="index"
                  :prop="item"
                  :label="item"
                />
              </el-table>
              <!-- 其他类型表格渲染（否则渲染table_location） -->
              <div v-else v-html="ocrTableHtml" class="other-table"></div>
            </div>
            <!-- JSON -->
            <div class="json-box" v-if="ocrActiveType==='3'">
              <!-- 复制 -->
              <span class="handle-box">
                <Copyable
                  :text="JSON.stringify(ocrContentObj.json_data)"
                  :color="'#1d65a8'"
                ></Copyable>
              </span>
              <!-- json数据 -->
              <vue-json-pretty :data="ocrContentObj.json_data"> </vue-json-pretty>
            </div>
          </div>
        </div>
        
        <div class="rf ac jsb">
        <!-- 时间 -->
        <span class="time">{{itemObj.answerTime}}</span>
        <!-- 操作按钮 -->
        <div class="bar" v-if="!itemObj.unneedHandle">
          <!-- 复制 -->
          <span class="bar-icon-item">
            <el-tooltip
              class="box-item"
              effect="dark"
              content="复制回答"
              placement="top"
              v-if="itemObj.questionType==='bigModelChat'"
            >
              <Copyable
                :text="itemObj.orgContent"
                :color="'#606266'"
              ></Copyable>
            </el-tooltip>
          </span>
          <!-- 下载 -->
          <span
            class="bar-icon-item"
            v-if="['plainTextClassify', 'fileClassify', 'plainTextGoodsMatch', 'fileGoodsMatch'].includes(itemObj.questionType) && isAIResult"
            @click="download">
            <!-- 下载按钮提示文案-需求：所以文件输入类型 始终展示，鼠标移入后消失 -->
            <div class="bar-warn" v-if="isShowDownloadWarn">
              下载查看更多
            </div>
            <!-- 下载按钮 -->
            <i
              class="plantmate plantmate-forms-softwareDownloadReport"
              @mouseenter="toggleDownloadVisible(false)"
              @mouseleave="toggleDownloadVisible(true)"
            ></i>
          </span>
          <!-- 好评 -->
          <span
            class="bar-icon-item"
            :class="{ highlight: itemObj.signGood }"
            @click="answerSign('signGood')">
            <i
              class="plantmate plantmate-ai-like2"
            ></i>
          </span>
          <!-- 差评 -->
          <el-popover
            placement="bottom"
            width="400"
            trigger="manual"
            v-model="signBadVisible"
            :fallback-placements="['bottom','top','right','left']">
            <div class="bad-reason-box">
              <div class="box-title">
                感谢你帮助皮小智成长
                <i class="el-icon-close"
                  @click="signBadVisible=false"
                ></i>
              </div>
              <el-form :model="form" style="min-width: 300px">
                <el-form-item>
                  <el-checkbox-group v-model="form.reasonList">
                    <el-checkbox v-for="(item, index) in reasonCheckboxList" :key="index" 
                        :value="item" :label="item"/>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="其他">
                  <el-input
                    v-model="form.reasonDesc"
                    type="textarea"
                    placeholder="最多输入255字符"
                    maxlength="255"
                    show-word-limit 
                  />
                </el-form-item>
                <el-form-item class="btn-box">
                  <el-button type="primary" @click="onSubmit" size="small">提交</el-button>
                </el-form-item>
              </el-form>
            </div>
            <template v-slot:reference>
              <span
                class="bar-icon-item"
                :class="{ highlight: itemObj.signBad }"
                @click="answerSign('signBad')">
                <i
                  class="plantmate plantmate-ai-like2 trf180"
                ></i>
              </span>
            </template>
          </el-popover>
          <!-- 编辑 -->
          <span
            class="bar-icon-item"
            v-if="['plainTextClassify', 'fileClassify', 'plainTextGoodsMatch', 'fileGoodsMatch'].includes(itemObj.questionType) && isAIResult"
            @click="toEdit">
            <i class="el-icon-edit-outline"></i>
          </span>
          <!-- 去下单（false暂时隐藏） -->
          <span
            class="bar-icon-item"
            v-if="['ocr'].includes(itemObj.questionType) && isAIResult && false"
          >
            <el-select
              v-model="orderType"
              clearable
              placeholder="去下单"
              style="width: 96px"
              size="small"
              @change="createOrder"
            >
              <el-option
                v-for="item in orderOpt"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                @click="createOrder"
              />
            </el-select>
          </span>
          <el-pagination small hide-on-single-page :current-page="pageNo" :page-size="1" layout="prev, pager, next" :total="ocrContentList.length" />
        </div>
        <!-- 复制按钮：物料助手-开场白 -->
        <div
          class="bar"
          v-if="itemObj.questionType==='sourceAssistant' && itemObj.isprologue && itemObj.copyText"
        >
          <Copyable
            :text="itemObj.copyText"
            :color="'#606266'"
          ></Copyable>
        </div>
        </div>

      </div>

    </div>

    <!-- 预览OCR报表 -->
    <el-dialog v-model="ocrTableVisible" title="OCR识别表格预览" width="800px">
      <!-- 票证类型表格渲染（有tables渲染tables） -->
      <el-table
        v-if="ocrTableKeyList.length>0"
        :data="ocrContentObj.tables[0]"
        size="small"
        border
        style="width: 100%"
        max-height="700"
        :header-cell-style="{ 'background-color': '#f5f7fa', padding: '5px 0' }"
      >
        <el-table-column v-for="(item, index) in ocrTableKeyList" :key="index" :prop="item" :label="item" />
      </el-table>
      <!-- 其他类型表格渲染（否则渲染table_location） -->
      <div v-else v-html="ocrTableHtml" class="ocrTableBox"></div>
    </el-dialog>
    
    <!-- 标前询价单创建预览 -->
    <!-- <PreCreateInquiryOrder
      v-if="inquiryOrderVisible"
      :visible="inquiryOrderVisible"
      :createOrderContent="createOrderContent"
      @toggleInquiryOrderVisible="toggleInquiryOrderVisible"
    ></PreCreateInquiryOrder> -->

    <!-- 销售订单创建预览 -->
    <!-- <PreCreateSaleOrder
      v-if="saleOrderVisible"
      :visible="saleOrderVisible"
      :createOrderContent="createOrderContent"
      @toggleSaleOrderVisible="toggleSaleOrderVisible"
    ></PreCreateSaleOrder> -->
  </div>
</template>

<script>
import Copyable from '@/components/copyable.vue';
import { Base64 } from "js-base64";
import { exportFun } from "@/utils/export";
// import VueJsonPretty from 'vue-json-pretty';
// import 'vue-json-pretty/lib/styles.css';
// import PreCreateInquiryOrder from './common/PreCreateInquiryOrder.vue'
// import PreCreateSaleOrder from './common/PreCreateSaleOrder.vue'
import { openOther } from '@/utils/index';

export default {
  name: 'ChatReply',
  components: {
    Copyable,
    // VueJsonPretty,
    // PreCreateInquiryOrder,
    // PreCreateSaleOrder
  },
  props: {
    itemObj: {
      type: Object
    }
  },
  computed: {
    isAIResult(){
      // 是否有AI回答
      if(this.itemObj.content.indexOf("暂时无法回答该问题") === -1 && this.itemObj.content.indexOf('作答中') === -1){
        return true
      } else {
        return false
      }
    },
    reasonCheckboxList(){
      // 差评原因选项
      if(['plainTextClassify', 'fileClassify', 'plainTextGoodsMatch', 'fileGoodsMatch'].includes(this.itemObj.questionType)){
        return ['匹配错误','数据摘取错误']
      } else if(['ocr'].includes(this.itemObj.questionType)){
        return ['识别错乱','返回格式不准确','识别失败','识别结果不准确']
      } else {
        return []
      }
    },
    isOCRContent(){
      // 是否展示OCR识别结果内容
      if(this.itemObj.questionType!=='ocr' || !this.isJSON(this.itemObj.content)) return false
      const contentObj = JSON.parse(this.itemObj.content)
      if(contentObj instanceof Array && contentObj.length>0){
        this.ocrContentList = contentObj
        return true
      } else{
        return false
      }
    },
    ocrContentObj(){
      // OCR识别结果内容
      if(this.isOCRContent){
        return this.ocrContentList[this.pageNo-1]
      } else {
        return null
      }
    },
    ocrTableKeyList() {
      // OCR识别结果内容-表格处理 (票证类型)
      if(this.isOCRContent && this.ocrContentObj.tables && this.ocrContentObj.tables.length>0){
        //取第一个表格的key
        return Object.keys(this.ocrContentObj.tables[0][0])
      } else {
        return []
      }
    },
    ocrTableHtml() {
      // OCR识别结果内容-表格处理 (其他类型)
      if(!this.isOCRContent) return ''
      const wordsBlocklist = this.ocrContentObj.table_location ? this.ocrContentObj.table_location[0] : []
      if(!wordsBlocklist || wordsBlocklist.length<=0) return ''
      // 表体处理
      var tableHtml = `<table><tbody><tr>`
      wordsBlocklist.forEach((item,index)=>{
        if(index>=1){
          var lastItem = wordsBlocklist[index-1]
          if( item.columns.includes(0) || (Math.min(...item.rows)>=Math.max(...lastItem.rows) && Math.max(...item.columns)<=Math.min(...lastItem.columns)) ){ //换行
            tableHtml = `${tableHtml}</tr><tr>`
          }
        }
        tableHtml = `${tableHtml}<td rowspan="${item.rows.length}" colspan="${item.columns.length}">${item.words}</td>`
      })
      tableHtml = `${tableHtml}</tr></tbody></table>`
      return tableHtml
    },
    isShowDownloadWarn() {
      // 是否展示下载按钮提示文案：downloadWarnVisible为true，且为文件输入类型
      return this.downloadWarnVisible && ['fileClassify', 'fileGoodsMatch'].includes(this.itemObj.questionType)
    },
    isShowAddMore() {
      // 是否展示快捷键-增加推荐商品数量
      return this.downloadWarnVisible && ['plainTextGoodsMatch', 'fileGoodsMatch'].includes(this.itemObj.questionType) && this.isAIResult
    }
  },
  data() {
    return {
      cronPopover: false,
      signBadVisible: false,
      form: {
        reasonList: [],
        reasonDesc: ''
      },
      downloading: false,

      ocrActiveType: "1", //OCR内容展示类型
      ocrDownloading: false, //OCR下载按钮loading

      ocrTableVisible: false, //OCR报表预览弹窗

      downloadWarnVisible: true, //下载按钮提示文案

      // OCR-去下单
      orderOpt: [
        { label: '标前询价单', value: '1'},
        { label: '销售订单', value: '2'}
      ],
      orderType: '',
      inquiryOrderVisible: false, //标前询价单创建预览弹窗
      saleOrderVisible: false, //销售订单创建预览弹窗
      createOrderContent: '', //去下单接口入参
      ocrContentList: [],
      pageNo: 1
    }
  },
  methods: {
    // 好评/差评
    answerSign(key){
      if(key==='signBad' && (!this.itemObj.signBad || this.itemObj.signBad===false)){
        //差评原因弹窗
        this.signBadVisible = true
        return
      }
      const signData = {
        [key]: !this.itemObj[key]
      }
      this.$emit('answerSign', signData, this.itemObj)
    },
    // 差评内容提交
    onSubmit(){
      const signData = {
        badReasons: JSON.parse(JSON.stringify(this.form.reasonList)),
        signBad: true
      }
      if(this.form.reasonList.length>0) signData['badReasons']=JSON.parse(JSON.stringify(this.form.reasonList))
      if(this.form.reasonDesc) signData['otherBadReason']=this.form.reasonDesc
      this.$emit('answerSign', signData, this.itemObj)
      this.signBadVisible = false
      //清除上次数据
      this.form.reasonList = []
      this.form.reasonDesc = ''
    },
    // 智能分类-下载
    download(){
      if(this.downloading) return

      this.downloading = true;
      // 导出前校验是否已完成（若已完成或者参数force=true则直接下载）
      this.$http
        .post(`/help/ai/user/data/questionResult/exportCheck`, {questionId: this.itemObj.questionId},{
          //@ts-ignore
          noMessage:true //不弹窗提示错误信息
        })
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.doExport()
          } else if(res.code === 910001){
            this.$confirm(res.message, '温馨提示', {
              type: 'warning'
            }).then(() => {
              this.doExport()
            }).catch(() => {
              this.downloading = false
            })
          } else {
            this.downloading = false;
          }
        }).catch(() => {
          this.downloading = false;
        });
    },
    doExport(){
      exportFun({
        url: '/help/ai/user/data/questionResult/export',
        params:{
          questionId: this.itemObj.questionId
        }
      })
      .then(res => {
        this.downloading = false;
        // this.$message.success("文件正在下载！");
      })
      .catch(error => {
        this.downloading = false;
        this.$message.error("下载失败！");
      });
    },
    // 智能分类-编辑
    toEdit(){
      let path = ''
      if(['plainTextClassify', 'fileClassify'].includes(this.itemObj.questionType)){
        path = '/categories'
      } else if(['plainTextGoodsMatch', 'fileGoodsMatch'].includes(this.itemObj.questionType)){
        path = '/products'
      }
      this.$router.push({
        path,
        query: {
          questionId: Base64.encode(this.itemObj.questionId)
        }
      })
    },

    initOcrActiveType(){
      if(!this.isOCRContent) return
      if(this.ocrContentObj.key_values.length>0){
        this.ocrActiveType = '1'
      } else if(
        (this.ocrContentObj.tables && this.ocrContentObj.tables.length>0) ||
        (this.ocrContentObj.table_location&&this.ocrContentObj.table_location.length>0)
      ){
        this.ocrActiveType = '2'
      } else {
        this.ocrActiveType = '3'
      }
    },
    //OCR-内容展示类型选择
    selectDataType(tab, event){
      this.$nextTick(()=>{
        console.log(this.ocrActiveType)
      })
    },
    //OCR-下载结果
    ocrResultExport(type){
      console.log('下载结果')
      if(this.ocrDownloading) return

      this.ocrDownloading = true;
      exportFun({
        url: '/help/ai/user/data/questionResult/export',
        params:{
          questionId: this.itemObj.questionId,
          exportFormat: type
        }
      })
      .then(res => {
        this.ocrDownloading = false;
        // this.$message.success("文件正在下载！");
        this.$emit('ocrResultExport',type, this.itemObj) //成功后刷新列表，更新downType状态
      })
      .catch(error => {
        this.ocrDownloading = false;
        this.$message.success("下载失败！");
      });

      this.$refs.downTypePopover.hide()
    },
    // 预览OCR报表
    reviewOcrTable(){
      this.ocrTableVisible = true
    },

    //判断是否是JSON.stringify格式
    isJSON(str) {
      if (typeof str == "string") {
        try {
          var obj=JSON.parse(str);
          if(typeof obj == 'object' && obj ){
            return true;
          }else{
            return false;
          }
        } catch(e) {
          return false;
        }
      }
    },

    // 增加推荐商品数量
    addMoreNums() {
      this.$emit('addMoreNums','增加推荐商品数量',this.itemObj)
    },
    clickContent(event){
      if (event.target.tagName.toLowerCase() === 'a' && event.target.className === 'shortcutKey') {
        this.addMoreNums()
      }
      if (
        ['materialAssistant'].includes(this.itemObj.questionType)
        && event.target.tagName.toLowerCase() === 'a'
        && event.target.href.indexOf('goodDetail')!=-1
      ) {
        // 物料助手 商品详情a链接
        event.preventDefault() // 阻止默认跳转
        // PC端数据：spuId，移动端数据：defaultSpuId
        const paramName = event.target.href.indexOf('spuId')!=-1 ? 'spuId'
                        : event.target.href.indexOf('defaultSpuId')!=-1 ? 'defaultSpuId'
                        : null
        if(!paramName) return
        const spuId = this.getQueryParam(event.target.href, paramName);
        this.$request
          .get(`/front/cross/commodity-user/spu-status/${spuId}`)
          .then((res) => {
            if(res==5){
              // 上架 跳转到商品详情页
              openOther(`goodDetail?spuId=${spuId}`)
            } else {
              // 下架
              this.$message.warning('该商品已下架，无法查看详情。');
              return
            }
          })
      }
    },
    getQueryParam(url, param) {
      // 正则匹配链接 ? 或 & 后面跟随的参数名称和其值
      const regex = new RegExp('[?&]' + param + '=([^&#]*)', 'i');
      const result = regex.exec(url);
      return result ? decodeURIComponent(result[1]) : null;
    },

    toggleDownloadVisible(flag){
      this.downloadWarnVisible = flag
    },

    // 去下单
    createOrder(){
      if(this.orderType){
        let content = ''
        if(this.ocrContentObj){
          let { key_values, tables, table_location } = { ...this.ocrContentObj }
          content = { key_values, tables, table_location }
        }
        this.createOrderContent = JSON.stringify(content)

        if(this.orderType==='1') { //标前询价单
          this.toggleInquiryOrderVisible(true)
        } else if(this.orderType==='2') { //销售订单
          this.toggleSaleOrderVisible(true)
        }
      } else { //未选
        this.toggleInquiryOrderVisible(false)
        this.toggleSaleOrderVisible(false)
      }
    },
    toggleInquiryOrderVisible(flag){
      this.inquiryOrderVisible = flag
    },
    toggleSaleOrderVisible(flag){
      this.saleOrderVisible = flag
    }

  },
  mounted(){
    this.initOcrActiveType()
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/chat/chat-reply.scss";

.is-loading {
  animation: rotate360 2s linear infinite; /* 2秒完成一个周期的旋转，无限循环 */
}
/* 定义旋转动画 */
@keyframes rotate360 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
